import { render, staticRenderFns } from "./shareItem.vue?vue&type=template&id=2a7fca94&scoped=true&"
import script from "./shareItem.vue?vue&type=script&lang=js&"
export * from "./shareItem.vue?vue&type=script&lang=js&"
import style0 from "./shareItem.vue?vue&type=style&index=0&id=2a7fca94&scoped=true&lang=less&"
import style1 from "./shareItem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7fca94",
  null
  
)

export default component.exports